import { facultyData } from '../facultyData';

export const commerceData = {
  departmentName: "Department of Commerce",
  bannerImage: "/infrastructure/commerce/class-1.JPG",
  
  about: {
    title: "About the Department",
    content: `The Department of Commerce was established in the academic year 2012 and currently offers both Under-Graduate and Post-Graduate programs. The Post-Graduate program, M.Com, has an intake of 40 students, while the Under-Graduate program, B.Com (Computer Applications) Honours, admits 50 students. The Department also offers a Tally Certificate Course to enhance students' practical skills.

A team of highly dedicated and well-qualified faculty members with rich academic and research experience work continually to provide quality education. The Department is committed to shaping students into future leaders, encouraging creative and innovative thinking, and equipping them to meet the challenges and competition of the global environment.`,
    highlights: [
      "Post-Graduate program: M.Com with 40 seats intake",
      "Under-Graduate program: B.Com (Computer Applications) Honours with 50 seats",
      "Tally Certificate Course for practical skills enhancement",
      "Highly dedicated and well-qualified faculty with rich academic and research experience",
      "Focus on shaping future leaders with creative and innovative thinking",
      "Preparation for global challenges and competition"
    ]
  },

  vision: "To prepare students from diverse backgrounds including underprivileged or socially disadvantaged for successful academic and professional careers in commerce, business, and related fields.",

  mission: "To develop students' knowledge and skills in diverse commerce-related domains (accounting, finance, marketing, management, etc.), equipping them to meet challenges in real-world business and economic environment.",

  objectives: [
    "Impart a strong foundation in fundamentals of commerce (accounting, finance, business law, management, etc.) so that graduates are well-prepared for careers in industry, business, finance, or further studies.",
    "Equip students with analytical, critical thinking and decision-making abilities, enabling them to handle complex business/economic problems.",
    "Prepare students to be socially responsible citizens — aware of societal needs, equity and social justice — aligning with the university's commitment to uplift underprivileged sections."
  ],

  brochure: {
    title: "Department Brochure",
    pdfLink: "/commerce/department-brochure.pdf",
    description: "Download our comprehensive department brochure for detailed information."
  },

  hod: {
    id: "com001",
    name: "Dr. N. Moses",
    designation: "Co-ordinator & Assistant Professor (C)",
    photo: "/commerce/moses.JPG",
    email: "drmosesknl@gmail.com",
    mobile: "9885499307",
    qualification: "M.Com, MBA (Finance), NET, SET, Ph.D.",
      specialization: "Finance,  Digital Payments",
    message: `Welcome to the Department of Commerce at Rayalaseema University. Our department is dedicated to providing quality education and fostering academic excellence in the field of commerce and business studies.`,
    profileLink: "/commerce/moses.pdf",
    achievements: [
      "Awarded Best Teacher of the Year Excellence in Teaching Award-2025, Council for Skills and Competencies (CSC India) on 5th September 2025",
      "Gurram Joshua Visistaseva Puraskaaram-2025, Gurram Joshua Excellence Award, Navyandhra Pradesh Vidyarthi Samakya Dravida Naadu Samkhyema Samgam, APJA & LSF, 130th Birth Day Anniversary Celebrations of Gurram Joshua"
    ]
  },

  bos: {
  title: "Commerce",
  members: [
    {
      name: "Prof. C. Viswanadha Reddy",
      designation: "Chairperson",
      affiliation: "Dept. of M.B.A, Rayalaseema University, Kurnool"
    },
    {
      name: "Prof. A. Sudhakar",
      designation: "Member",
      affiliation: "Director, Academics, Dr. B.R. Ambedkar Open University, Hyderabad"
    },
    {
      name: "Prof. Anjaneyulu",
      designation: "Member",
      affiliation: "Dept. of Commerce, S.K. University, Anantapur"
    },
    {
      name: "Prof. M. Raja Sekhar",
      designation: "Member",
      affiliation: "S.V. University, Tirupati"
    },
    {
      name: "Prof. Jaladi Ravi",
      designation: "Member",
      affiliation: "Andhra University, Visakhapatnam"
    },
    {
      name: "Dr. P. Amarnath Reddy",
      designation: "Member",
      affiliation: "Senior Project Manager, ICAR, Rajendra Nagar, Hyderabad"
    },
    {
      name: "Prof. S. Raghunatha Reddy",
      designation: "Member",
      affiliation: "Dept. of Commerce, Y.V. University, Kadapa"
    }
  ]
}
,

 
  faculty: [

    {
      id: "com001",
      name: "Dr. N. Moses",
      designation: "Co-ordinator & Assistant Professor (C)",
      department: "Commerce",
      email: "drmosesknl@gmail.com",
      mobile: "9885499307",
      photo: "/commerce/moses.JPG",
      qualification: "M.Com, MBA (Finance), NET, SET, Ph.D.",
      specialization: "Finance,  Digital Payments",
      dateOfBirth: "22-06-1982",
      dateOfJoining: "23-08-2013",
      experience: {
        teaching: "14 Years",
        industry: "4 Years",
        total: "18 Years"
      },
      publications: {
        journalsInternational: 5,
        journalsNational: 3,
        conferences: 4,
        booksChapters: 3
      },
      profiles: {
        orcid: "0009-0006-0711-9655",
        scholar: "https://scholar.google.com/citations?user=VhhjtN0AAAAJ",
        vidwan: "454527"
      },
      profileLink: "/commerce/moses.pdf"
    },

    {
      id: "com002",
      name: "Dr. V. V. L. Leelakumari",
      designation: "Assistant Professor (C)",
      department: "Commerce",
      email: "leelakotika@gmail.com",
      mobile: "9885492845",
      photo: "/commerce/leelakumari.JPG",
      qualification: "M.Com, Ph.D.",
      specialization: "Accounting, Financial Management",
      experience: {
        teaching: "10+ Years"
      },
      profileLink: "/commerce/leela.pdf"
    },

    {
      id: "com003",
      name: "Dr. R. Bharathi",
      designation: "Assistant Professor (C)",
      department: "Commerce",
      email: "bharathi@gmail.com",
      mobile: "9441657691",
      photo: "/commerce/bharathi.JPG",
      qualification: "M.Com, Ph.D.",
      specialization: "Commerce & Management Studies",
      experience: {
        teaching: "8+ Years"
      },
      profileLink: "/commerce/barathi.pdf"
    },

    {
      id: "com004",
      name: "Dr. M. Yugandharudu",
      designation: "Assistant Professor (C)",
      department: "Commerce",
      email: "m.yugandhar12@gmail.com",
      mobile: "8374348953",
      photo: "/commerce/yugandarudu.JPG",
      qualification: "M.Com, Ph.D.",
      specialization: "Accounting, Taxation",
      experience: {
        teaching: "9+ Years"
      },
      profileLink: "/commerce/yugandarudu.pdf"
    }

  ]

,

  courses: {
    undergraduate: [
      {
        name: "B.Com (Computer Applications) ",
        duration: "3 Years (6 Semesters)",
        eligibility: "10+2 or Intermediate from a recognized board (Commerce, Science, or Arts streams). Minimum aggregate percentage as prescribed by the university.",
        intake: "50 seats",
        description: "The Bachelor of Commerce (Computer Applications) is an undergraduate program that combines core commerce education with essential computer and technological skills. This program is designed to equip students with a strong foundation in accounting, finance, business management, and information technology, preparing them for the digital demands of modern business environments.",
        programObjectives: [
          "To provide an in-depth understanding of commerce and business fundamentals integrated with advanced computer applications essential for modern business operations.",
          "To develop strong technical skills in programming, database management, analytics tools, and business software, enabling students to effectively use technology in organizational decision-making.",
          "To enhance analytical, problem-solving, and entrepreneurial abilities so students can apply digital solutions to real-world business challenges and explore innovative business opportunities.",
          "To prepare students for professional careers and higher studies by building competencies in communication, leadership, and industry-relevant technologies, ensuring readiness for careers in finance, IT-enabled services, e-commerce, and business analytics."
        ],
        structure: "6 semesters over 3 academic years with an option to exit with a 3-year degree (without honours) as per NEP guidelines. Completion of the 4th year includes Honours/Research/Advanced courses."
      }
    ],
    postgraduate: [
      {
        name: "M.Com (Master of Commerce)",
        duration: "2 Years (4 Semesters)",
        eligibility: "Bachelor's degree in Commerce (B.Com) or equivalent from a recognized university. Students from related disciplines such as BBA, B.A. Economics, or other commerce-related programs may also be eligible. Minimum aggregate 50% (40% for SC/ST/PH) required.",
        intake: "40 seats",
        description: "The Master of Commerce (M.Com) program is a postgraduate degree designed to provide advanced knowledge and professional competence in commerce, finance, accounting, business management, and related fields. It aims to equip students with a deep understanding of contemporary business practices, economic systems, financial markets, and organizational management.",
        programObjectives: [
          "To provide advanced knowledge in commerce, accounting, finance, and management, enabling students to gain strong theoretical and practical expertise.",
          "To develop analytical, research, and problem-solving skills required for effective decision-making in business and financial sectors.",
          "To enhance professional competence through case studies, project work, seminars, and practical exposure to industry-oriented practices.",
          "To prepare students for careers and higher studies by building leadership, communication skills, and ethical values essential for roles in corporate sectors, academia, and entrepreneurship.",
          "To enhance professional competencies through practical exposure, case studies, internships, and industry-oriented training."
        ],
        framework: "Follows Choice Based Credit System (CBCS) or the academic structure of the respective university."
      }
    ],
    // research: [
    //   {
    //     name: "Ph.D. in Commerce",
    //     duration: "Minimum 3 Years",
    //     eligibility: "M.Com or equivalent with required percentage",
    //     areas: "Accounting, Finance, Taxation, Banking, Marketing, Human Resource Management, Entrepreneurship, Business Technologies"
    //   }
    // ],
    certificates: [
      {
        name: "Tally Certificate Course",
        description: "Professional certification program to enhance practical accounting skills using Tally software"
      }
    ]
  },

  
    Infrastructure: [
  "/infrastructure/commerce/class-1.JPG",
  "/infrastructure/commerce/class-2.JPG",

]
  ,

  research: {
    title: "Research Information",
    description: "The Department of Commerce actively promotes a culture of research and academic inquiry among faculty and students. The department encourages research initiatives in areas such as accounting, finance, marketing, human resource management, entrepreneurship, and emerging business technologies.",
    activities: [
      "Faculty members publishing research papers in reputed national and international journals",
      "Presentations at conferences, seminars and workshops",
      "Student research projects, surveys, and case studies",
      "Access to reference materials and digital resources",
      "Academic guidance from experienced faculty members"
    ],
    publications: {
      national: 12,
      international: 27,
      books: 7,
      studentProjects: 181
    }
  },

  facultyAchievements: [
    {
      name: "Dr. N. Moses",
      achievements: [
        "Awarded Best Teacher of the Year Excellence in Teaching Award-2025, Council for Skills and Competencies (CSC India) on 5th September 2025",
        "Gurram Joshua Visistaseva Puraskaaram-2025, Gurram Joshua Excellence Award, Navyandhra Pradesh Vidyarthi Samakya Dravida Naadu Samkhyema Samgam, APJA & LSF, 130th Birth Day Anniversary Celebrations of Gurram Joshua"
      ]
    },
    {
      name: "Dr. VVL Leela Kumari",
      achievements: [
        "Awarded Best Teacher in 2017, Association of Alliance Club International, Alliance Club of Greater Kurnool & Kurnool Higher Education - on World Teachers Day"
      ]
    },
    {
      name: "Dr. M. Yugandharudu",
      achievements: [
        "Great Guru Spandana Teacher Award – 2021, Spandana Eda International Foundation",
        "Gurram Joshua Visistaseva Puraskaaram-2025, Gurram Joshua Excellence Award, Navyandhra Pradesh Vidyarthi Samakya Dravida Naadu Samkhyema Samgam, APJA & LSF, 130th Birth Day Anniversary Celebrations of Gurram Joshua"
      ]
    }
  ],

  // events: [
  //   {
  //     title: "Commerce Summit 2025",
  //     date: "March 2025",
  //     description: "Annual commerce event with industry experts, workshops, and seminars on contemporary business practices",
  //     type: "Summit"
  //   },
  //   {
  //     title: "Entrepreneurship Development Workshop",
  //     date: "Ongoing",
  //     description: "Regular workshops to foster entrepreneurial skills and innovative thinking among students",
  //     type: "Workshop"
  //   },
  //   {
  //     title: "Industry Internship Program",
  //     date: "Annual",
  //     description: "Practical training and internship opportunities with leading organizations in banking, finance, and business sectors",
  //     type: "Training"
  //   }
  // ]
};